module.exports = __webpack_public_path__ + "static/media/Loading_Dye_LD.59110a84.svg";